import CodecrackerCell from '../models/CodecrackerCell'
import api from '@puzzleapps/shared/src/utils/api'

import {
    state as baseState,
    getters as baseGetters,
    actions as baseActions,
    mutations as baseMutations,
} from '@puzzleapps/shared/src/store/modules/grid'

// TODO: Make cells array one dimensional
const state = {
    ...baseState,
    isPencil: false,
    givens: [], // store given letters to avoid looping the entire grid so much
    codeCrackerLetters: null,
}

const getters = {
    ...baseGetters,
}

const actions = {
    ...baseActions,

    fetchPuzzle({ commit, dispatch, rootState, state }) {
        commit('SET_LOADED', false)
        commit('SET_SELECTED_CELL', null)
        
        return new Promise((resolve, reject) => {
            let puzzleId = rootState.game.puzzleId
            if (!puzzleId) throw new Error('Puzzle id must be specified.')

            api.data(puzzleId)
                .then(data => {
                    
                    commit('SET_CODECRACKER_GRID', data)
                    dispatch('loadUserDataFromLocal', puzzleId)
                    dispatch('setCodecrackerKeyboardLayout')
                    dispatch('keyboard/createKeyboard', null, {root: true})
                    dispatch('responsiveKeyboardLayout')
                    dispatch('disableInitialUsedKeys', puzzleId)
                    commit('SET_LOADED', true)
                    resolve(data)
                })
        })
    },

    disableInitialUsedKeys({ dispatch, rootState }) {
        let gameMode = rootState.userSettings.gameMode
        
        dispatch('forEachCell', cell => {
            if (cell.input !== 0 || cell.given) {
                
                if(cell.input != cell.solution && cell.input !== 0)
                {
                    dispatch('keyboard/incorrectKey', cell.input.toUpperCase(), { root: true }) 
                }
                else{
                    dispatch('keyboard/correctKey', cell.solution.toUpperCase(), { root: true })
                }

            }        
        })
        //disable the key on the keyboard

        let givens = rootState.grid.givens

        for(let i = 0; i < givens.length; i++){
            dispatch('keyboard/removeKeyStyles', givens[i], { root: true })
            dispatch('keyboard/disableKey', givens[i], { root: true })
        }

    },

    setCodecrackerKeyboardLayout({ dispatch, state }) {
        dispatch('keyboard/setLayout', {
            rows: 3, 
            letters: state.codeCrackerLetters, 
            vertical: true, 
            name: 'codecracker'
        }, {root: true})

        dispatch('keyboard/setLayout', {
            rows: 3, 
            letters: state.codeCrackerLetters, 
            vertical: false, 
            name: 'codecracker-mobile'
        }, {root: true})
    },

    responsiveKeyboardLayout({ dispatch }) {
        if (window.innerWidth < 768)
        {
            dispatch('keyboard/switchLayout', 'codecracker-mobile', {root: true})
        }
        else {
            dispatch('keyboard/switchLayout', 'codecracker', {root: true})
        }
    },

    // pos = {row, col, input}
    setInputAtPos({ commit, dispatch, state, rootState, getters }, payload) {
        if (!payload) 
            throw new Error('Cell row and payload required. Given: ' + payload)

        const cell = state.cells[payload.row][payload.col]

        if (cell.input == payload.input) return

        if (!payload.isUndo) 
        {
            dispatch('undoRedo/clearRedoHistory', null, { root: true })
            dispatch('undoRedo/pushHistory', {
                row: payload.row,
                col: payload.col,
                input: cell.input,
            }, { root: true })
        }

        
        dispatch('setCodeCrackerInput', payload)
        dispatch('checkCompleted')
    },

    setCodeCrackerInput({ commit, getters, dispatch, state }, payload) {
        // return new Promise((resolve, reject) => {
        // set all letters in group
        const cell = state.cells[payload.row][payload.col]
        const prevLetter = cell.input
        const inputs = [...new Set(getters.getUserinputs)]

        

        // prevent the same leter from being entered twice
        if (payload.input !== 0 && (inputs.includes(payload.input) || state.givens.includes(payload.input) ))  
            return dispatch('notification/notify', 'Letter already used!', { root: true })

        if (payload.input !== 0)
        {
            if (prevLetter !== 0) dispatch('keyboard/removeKeyStyles', prevLetter, { root: true })
            {
                
                //dispatch('keyboard/disableKey', payload.input, { root: true })
                dispatch('keyboard/removeKeyStyles', payload.input, { root: true })

                if(payload.input === cell.solution)
                {
                    dispatch('keyboard/correctKey', payload.input, { root: true })
                }
                else
                {
                    dispatch('keyboard/incorrectKey', payload.input, { root: true })
                }
            }
            
        }
        else //delete/backspace event
        {
            
            dispatch('keyboard/removeKeyStyles', state.cells[payload.row][payload.col].input, { root: true })
            dispatch('keyboard/enableKey', state.cells[payload.row][payload.col].input, { root: true })
        }

        if (!cell.clueNumber) return

        dispatch('forEachCell', c => {
            if (cell.clueNumber === c.clueNumber) 
            {
                commit('SET_USER_INPUT_AT_POS', {
                    row: c.row,
                    col: c.col,
                    input: payload.input,
                })
            }   
        })
    },
    clearAllCCInputs({ dispatch, commit, state }){
        
        for (let i = 0; i < state.rows; i++) 
        {
            for (let j = 0; j < state.cols; j++) 
            {
                let cell = state.cells[i][j]

                if(cell.input != 0){
                    dispatch('keyboard/removeKeyStyles', cell.input, { root: true })
                }
                commit('SET_USER_INPUT_AT_POS', {
                    row: i,
                    col: j,
                    input: 0,
                })
            }
        }

    },

}

const mutations = {
    ...baseMutations,

    SET_CODECRACKER_GRID(state, json) {
        state.cols = json.c 
        state.rows = json.r + 1 // add an extra row for the solution
        let refs = json.re
        let solution = json.t && json.t.replace(/ /g, "") // trim spaces from grid solution

        // clear givens
        state.givens = []
        // create empty cells
        let cells = [[]]
        let letters = []
      // loop the solution and build the first row
        for (let i = 0; i < state.cols; i++) 
        {
            let cell = new CodecrackerCell()
            cell.row = 0
            cell.col = i
            cell.isBlack = true

            if (typeof solution[i] !== "undefined" && solution[i] !== ' ') 
            {
                cell.isBlack = false
                cell.solution = solution[i]                    
                cell.given = false

                refs.forEach(ref => {
                    if (cell.solution === ref.l)
                        return cell.clueNumber = ref.r
                })
            }

            cells[0].push(cell)
        }
        
        for (let i = 0; i < state.rows; i++) 
        {
            let row = []

            for (let j = 0; j < state.cols; j++) 
            {
                let index = state.cols * i + j

                let cell = new CodecrackerCell()
                cell.row = i+1
                cell.col = j
                cell.isBlack = true

                if (json.s[index] !== '*') 
                {
                    cell.isBlack = false
                    cell.solution = json.s[index]
                    cell.given = json.hl.includes(cell.solution)

                    if (cell.given) state.givens.push(json.s[index])

                    letters.push(cell.solution)

                    refs.forEach(ref => {
                        if (cell.solution === ref.l)
                            return cell.clueNumber = ref.r
                    })
                }

                row.push(cell)
            }

            cells.push(row)
        }

        state.cells = cells

        state.givens = [...new Set(state.givens)]

        state.codeCrackerLetters = 
            [...new Set(letters) || []].filter((letter) => letter !== 'undefined').sort() // unique letters
    },

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}